import { render, staticRenderFns } from "./TeacherCenter.vue?vue&type=template&id=0882e6f6&scoped=true&"
import script from "./TeacherCenter.vue?vue&type=script&lang=js&"
export * from "./TeacherCenter.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCenter.vue?vue&type=style&index=0&id=0882e6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882e6f6",
  null
  
)

export default component.exports